import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseServiceWithFilter } from './base.service';
import { BaseFilterModel } from '@cl/shared/models/base/base-filter-model.model';
import { ExpenseType } from '@cl/shared/models/expenses/expense-type';
import { Observable } from 'rxjs';
import { CommandResult } from '@cl/shared/models';

@Injectable({ providedIn: 'root' })
export class ExpenseTypesService extends BaseServiceWithFilter<ExpenseType, BaseFilterModel> {
    constructor(httpClient: HttpClient) {
        super(httpClient, '/api/v1/expense-types/');
    }

    getAllExpenseTypesAvailableOnAdd(): Observable<CommandResult<ExpenseType[]>> {
        return this.httpClient.get<CommandResult<ExpenseType[]>>(`${this.baseApiUrl}available-on-add`);
    }
}
